import { Link } from 'react-router-dom';
import { animeList } from '@/mocks/anime';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20breathtaking%20cinematic%20anime%20style%20illustration%20featuring%20a%20vibrant%20fantasy%20cityscape%20at%20sunset%20with%20warm%20golden%20and%20coral%20tones%2C%20cherry%20blossom%20trees%20in%20full%20bloom%2C%20floating%20magical%20light%20particles%2C%20a%20distant%20castle%20silhouette%2C%20dramatic%20clouds%20with%20sunbeams%20breaking%20through%2C%20ethereal%20atmosphere%2C%20digital%20art%20masterpiece%2C%20rich%20warm%20color%20gradient%20from%20golden%20to%20deep%20rose&width=1920&height=1080&seq=hero-bg-anime&orientation=landscape"
          alt="91动漫 - 正版高清动漫在线观看平台"
          className="w-full h-full object-cover object-top"
          title="91动漫 - 高清动漫在线观看"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-black/45 via-black/30 to-black/60"></div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center pt-16">
        <span className="inline-block px-4 py-1.5 rounded-full bg-primary-500/90 text-white text-xs font-medium mb-5 backdrop-blur-sm">
          正版高清 · 免费追番
        </span>
        <h1 className="text-3xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-5 leading-tight">
          畅享极致<span className="text-accent-400">观番</span>体验
        </h1>
        <p className="text-sm md:text-base text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
          91动漫是深受动漫迷喜爱的在线动漫平台，提供海量高清正版动漫资源。<br className="hidden sm:block" />
          涵盖热血、恋爱、悬疑、奇幻等多种类型，免费在线观看与追番提醒，让每一位动漫爱好者都能畅享极致观番体验。
        </p>
        <div className="flex items-center justify-center gap-3 flex-col sm:flex-row">
          <Link
            to="/category/rexue"
            className="px-8 py-3 rounded-lg bg-primary-500 text-white font-medium text-sm hover:bg-primary-600 transition-all whitespace-nowrap cursor-pointer"
          >
            <i className="ri-play-circle-line mr-1.5"></i>立即观看
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-lg bg-white/15 text-white backdrop-blur-sm font-medium text-sm hover:bg-white/25 transition-all whitespace-nowrap cursor-pointer border border-white/20"
          >
            <i className="ri-information-line mr-1.5"></i>了解更多
          </Link>
        </div>

        <div className="mt-12 grid grid-cols-3 gap-4 max-w-lg mx-auto">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-white">10,000+</div>
            <div className="text-xs text-white/60 mt-1">番剧资源</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">500万+</div>
            <div className="text-xs text-white/60 mt-1">动漫爱好者</div>
          </div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-white">50+</div>
            <div className="text-xs text-white/60 mt-1">合作版权方</div>
          </div>
        </div>
      </div>
    </section>
  );
}